export function PageLoadingShimmer() {
  return (
    <div className='shimmer-background'>
      {/* <div className='cooking-lady'></div> */}
      <div className='floating-logo'></div>
    </div>
  );
}
